export const styles = theme => ({
  titleCardHeader: {
    color: '#263238',
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '-0.05px',
  },
  rootContentCard:{
    padding: '0px'
  },
  customCellHeader:{    
    color: '#546e7a',
    fontSize: '0.75rem',
    fontWeight: 500,
    padding: '14px 40px 14px 16px',
  },
  customCell:{
    padding: '14px 40px 14px 16px',
  },
  customText:{
    fontSize: '14px',
    fontWeight: 400,
  },
  rootActionCard:{    
    display: 'flex',
    padding: '16px 24px',
  },
  iconAction:{
    fontSize: '1.5rem'
  },
  btnStatus: {
    width: '6rem',
    minWidth: 80,
    fontSize: '0.675rem',
  },
  containerEdit: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    padding: theme.spacing(3),
  },
  buttonCancel: {
    marginLeft: '1rem'
  },
  containerGroupButtons: {
    padding: '16px'
  },
  groupButtons: {
    display: 'flex',
  },
  mlButon: {
    marginLeft: '0px'
  }
})
